import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto
} from "@remar/shared/dist/api/baseApiService";
import { File } from "@remar/shared/dist/models";

import { URLS } from "../services.constants";

export class FileVaultFilesService extends BaseApiService<
	File,
	Record<string, unknown>,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}
}

export const fileVaultFilesService = new FileVaultFilesService(URLS.FILEVAULTFILES);
